import Vue from 'vue'
import Vuex from 'vuex'
import bookingForm from './modules/bookingForm'
import browser from './modules/browser'
import map from './modules/map'
import auth from './modules/auth'
import summary from './modules/summary'
import operators from './modules/operators'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: { browser, bookingForm, map, auth, summary, operators }
})

export default store
